import React from 'react';
import { createPortal } from 'react-dom';
import { copyDocMenuLabel, pasteDocMenuLabel } from '../../../utils/docClipboard';

/**
 * Right-click menu for Browse: Copy on a doc, Paste on a folder / empty space.
 * Paste is omitted unless the in-app clipboard holds a doc.
 */
const BrowseContextMenu = ({
  menu,
  copied,
  pasting = false,
  onCopy,
  onPaste,
  onOpenInNewTab,
  onClose,
}) => {
  if (!menu) return null;
  const showCopy = menu.kind === 'doc' && menu.item;
  const showPaste = menu.kind === 'folder' || menu.kind === 'blank';
  const canPaste = Boolean(copied?.docId);
  if (!showCopy && !showPaste) return null;

  return createPortal(
    <div
      className="docs-browse__ctx"
      style={{ left: menu.x, top: menu.y }}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      {showCopy && (
        <>
          <button
            type="button"
            className="docs-browse__ctx-item"
            onClick={() => {
              onOpenInNewTab?.(menu.item);
              onClose?.();
            }}
          >
            Open in new tab
          </button>
          <button
            type="button"
            className="docs-browse__ctx-item"
            onClick={() => {
              onCopy?.(menu.item);
              onClose?.();
            }}
          >
            {copyDocMenuLabel(menu.item.name)}
          </button>
        </>
      )}
      {showPaste && (
        <button
          type="button"
          className="docs-browse__ctx-item"
          disabled={!canPaste || pasting}
          onClick={() => {
            if (!canPaste) return;
            onPaste?.(menu.kind === 'folder' ? menu.item.id : menu.folderId);
            onClose?.();
          }}
        >
          {canPaste ? pasteDocMenuLabel(copied.title) : 'Paste doc here'}
        </button>
      )}
    </div>,
    document.body
  );
};

export default BrowseContextMenu;
